module.exports = __webpack_public_path__ + "img/only-you.545b572a.svg";